import {
    Directive,
    Inject,
    ElementRef,
    forwardRef,
    OnDestroy,
    AfterViewInit
} from '@angular/core';

import { MasonryComponent } from './masonry.component';

@Directive({
    selector: '[masonry-brick], masonry-brick'
})
export class MasonryBrickComponent implements OnDestroy {

    constructor(
      public _element: ElementRef,
      @Inject(forwardRef(() => MasonryComponent)) public _parent: MasonryComponent
    ) { }

    ngAfterViewInit() {
      this._parent.add(this._element.nativeElement);
    }

    ngOnDestroy() {
      this._parent.remove(this._element.nativeElement);
    }
}
